
import { defineComponent } from 'vue';
import { auth } from '@/firebase/init';
import { FirebaseError } from 'firebase/app';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { authGeneralErrorHandle } from '@/firebase/authErrorHandle';
import { forceAllWorkplacesStateSingletonReset } from '@/firebase/database';

export default defineComponent({
  name: 'SignInPage',
  data() {
    return {
      username: '' as string,
      email: '' as string,
      password: '' as string,
      errMsg: '' as string
    };
  },
  mounted() {
    console.log('logging in');
  },
  methods: {
    async signIn() {
      console.log('signing in');
      try {
        forceAllWorkplacesStateSingletonReset();
        const userObj = await signInWithEmailAndPassword(
          auth,
          this.email,
          this.password
        );
        this.$router.push('/projectManager');
      } catch (e: FirebaseError | any) {
        if (e instanceof FirebaseError) {
          this.errMsg = authGeneralErrorHandle(e).msg;
        }
      }
    }
  }
});
